<template>
  <v-layout row justify-center>
    <error-message ref="errorDialog" />
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-text>
          <v-container class="pb-0">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>登録されるタグ</h3>
              </v-flex>
              <div id="tag-box" v-if="!showTags">
                <span class="chips" v-for="(chip, index) in postData.graph_tags" :key="index">{{ chip }}</span>
              </div>
              <v-flex xs12>
                <h3>ネタバレの有無</h3>
              </v-flex>
              <v-flex xs12>
                <b>{{ secretText }}</b>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-btn
                class="black--text font-weight-bold"
                color="primary"
                dark
                small
                @click="registerGraph"
                >公開</v-btn
              >
              <v-btn
                class="black--text font-weight-bold"
                color="primary lighten-1"
                small
                @click="saveGraph"
                >非公開</v-btn
              >
            </v-card-actions>
            <v-card-actions>
              <v-btn
                class="black--text font-weight-bold"
                color="gray"
                flat
                small
                @click="dialog = false"
                >キャンセル</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ErrorMessage from "@/components/parts/ApiErrorMessage.vue";

export default {
  props: {
    graphId: {
      type: Number,
      default: 0
    },
    baseGraphId: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    },
    tags: {
      type: Array,
      default: () => {
        [];
      }
    },
    flgSecret: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ErrorMessage
  },
  data() {
    return {
      showTags: false,
      dialog: false,
      spoiler: 0,
      tagString: "",
      secretText: "ネタバレなし",
      postData: {
        secret_flg: false,
        publish_flg: false,
        graph_tags: []
      }
    };
  },
  computed: {
    getTags() {
      return this.tags;
    },
    getFlgSecret() {
      return this.flgSecret;
    }
  },
  watch: {
    getTags() {
      this.setTags();
    },
    getFlgSecret() {
      this.setFlgSecret();
    }
  },
  methods: {
    setTags() {
      this.postData.graph_tags = this.tags;
    },
    setFlgSecret() {
      this.postData.secret_flg = this.flgSecret;
      if (this.flgSecret) {
        this.secretText = "ネタバレあり";
      }
    },
    show() {
      this.dialog = true;
    },
    /* タグデータとネタバレデータをDB登録します */
    registerGraph() {
      this.postData.publish_flg = true;

      this.$http
        .put(`/v1/graphs/publish/` + this.graphId, this.postData, {
          headers: {
            Authorization: "Bearer " + this.$store.state.login.auth_token
          }
        })
        .then(res => {
          this.$store.commit("setGraphTag", this.postData.graph_tags);
          this.$router.push({ name: "complete", query: { id: this.graphId } });
          this.dialog = false;
        })
        .catch(error => {
          this.$refs.errorDialog.setMessage(
            "グラフの公開処理に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
      if (!this.$route.query.mine) {
        this.share();
      }
    },
    saveGraph() {
      this.$http
        .put(`/v1/graphs/publish/` + this.graphId, this.postData, {
          headers: {
            Authorization: "Bearer " + this.$store.state.login.auth_token
          }
        })
        .then(res => {
          this.$store.commit("setGraphTag", this.postData.graph_tags);
          this.$router.push({ name: "mypage" });
          this.dialog = false;
        })
        .catch(error => {
          this.$refs.errorDialog.setMessage(
            "グラフの保存に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    },
    share() {
      const EP = "/v1/graphs/used/" + this.baseGraphId;
      this.$http
        .put(EP, {
          id: this.baseGraphId
        })
        .catch(error => {
          this.$refs.errorDialog.setMessage(
            "グラフの利用回数更新に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    }
  }
};
</script>

<style scoped lang="scss">
#tag-box {
  margin-top: 10px;
  margin-bottom: 30px;
}

.v-input--selection-controls {
  margin-top: 0;
}

span.chips {
  background: #e0e0e0;
  color: rgba(0,0,0,0.87);
  padding: 2px 12px;
  border-radius: 28px;
  margin: 4px;
  display: inline-block;
}
</style>
